export const initialTransferModalState = {
  id: '',
  sentAmount: '',
  sentCurrency: '',
  sentCommission: '0',
  sentCommissionCurrency: '',
  sentExchangeRate: '0',
  receivedAmount: '',
  receivedCurrency: '',
  receivedCommission: '0',
  receivedCommissionCurrency: '',
  receivedExchangeRate: '0',
  comment: '',
  fromWallet: '',
  toWalletId: '',
  inProgress: false,
  dateTime: '',
}
